import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GarageShareService {
  constructor() {}
  private garageDataSubject = new BehaviorSubject<any>(null);

  garageData = this.garageDataSubject.asObservable();

  setGarageData(data: any) {
    this.garageDataSubject.next(data);
  }
}
